import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import DataTable from '../../components/DataTable/DataTable';
import SectionCard from './SectionCard';

const columns = [
  { id: 'index', label: '#' },
  { id: 'branch', label: 'Branch name' },
  { id: 'IFSCCode', label: 'IFSC code' },
  { id: 'city', label: 'City' },
  { id: 'district', label: 'District' },
  { id: 'zone', label: 'Zone' },
  { id: 'state', label: 'State' },
  { id: 'country', label: 'Country' },
];

export default function Access({ data }) {
  return (
    <SectionCard
      Icon={AccountBalanceOutlinedIcon}
      title='Branch access'
      subtitle={data.length
        ? `${data.length} ${data.length === 1 ? 'branch is' : 'branches are'} assigned to you.`
        : 'Branches assigned to you.'}
      bodyless
    >
      <DataTable
        bare
        tableHead={columns}
        noDataText='No branches are assigned to you.'
        itemComponent={data.map((element, index) => (
          <TableRow key={element.id}>
            <TableCell>{index + 1}</TableCell>
            <TableCell>{element.branchName || ''}</TableCell>
            <TableCell>{element.ifscCode || ''}</TableCell>
            <TableCell>{element.city || ''}</TableCell>
            <TableCell>{element.district || ''}</TableCell>
            <TableCell>{element.zone || ''}</TableCell>
            <TableCell>{element.state || ''}</TableCell>
            <TableCell>{element.country || ''}</TableCell>
          </TableRow>
        ))}
      />
    </SectionCard>
  );
}
